
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "672d0dd2a20104bf148e55a78550ca2abda4e652",
    "version": "9.1.1"
};
/* tslint:enable */
